<template>
  <dd>
    <ul :class="`radio-area ${error ? 'is-error' : '' }`">
      <li v-for="(data, index) in listData" :key="index">
        <input :id="`${name}-${index}`" type="radio"
               :name="name"
               :value="data.id"
               :checked="value === data.id"
               @click="onSelectValue(data.id)"
        >
        <label :for="`${name}-${index}`">
          <span>{{ data.value }}
          </span>
        </label>
      </li>
    </ul>
    <p class="error-txt">{{ error }}</p>
  </dd>
</template>

<script>
  import { validateRequired } from '../../helpers/schemaValidate'

  export default {
    name: 'InputRadio',
    props: {
      name: {
        type: String,
        default: '',
      },
      error: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
      listData: {
        type: Array,
        default: () => {
          return [{
            key: '',
            value: '',
          }]
        },
      },
      textError: {
        type: String,
        default: '',
      },
      id: {
        type: String,
        default: '',
      },
    },
    watch: {
      value() {
        this.$emit('onValidate', this.name, '')
      },
    },
    methods: {
      onSelectValue(value) {
        this.$emit('onHandleChange', this.name, value)
        this.onValidate(value)
      },
      onValidate(value) {
        const values = {
          [this.name]: value,
        }
        validateRequired(this.name, this.textError)
          .validateAt(this.name, values)
          .then(() => {
            this.$emit('onValidate', this.name, '')
          })
          .catch(error => {
            this.$emit('onValidate', this.name, error.message)
          })
      },
    },
  }
</script>

<style scoped>

</style>
